import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import MainContainer from "../../components/MainContainer";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import { Typography, TextField, Button, Paper, Grid, Tooltip } from "@material-ui/core";
import UserTable from "./UserTable";
import RegionTable from "./RegionTable";
import { Link } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import Heading from "../../components/Heading";
import Loading from "../../components/loadingSpinner/Loading";
import { Prompt } from "react-router-dom";

@inject("organisationStore", "organisationMemberStore", "stateStore", "regionStore", "templateStore")
@observer
class StateEdit extends Component {
    state = {
        isLoading: false
    };

    constructor(props) {
        super(props);
        this.props.organisationMemberStore.reset();
        this.props.stateStore.reset();
        this.props.regionStore.reset();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.templateStore.openStateBlock();
        if (this.props.match.params.stateId) {
            this.setState(
                {
                    ...this.state,
                    isLoading: true
                },
                () => {
                    Promise.all([
                        this.props.organisationStore.load(this.props.match.params.id),
                        this.props.stateStore.loadState(this.props.match.params.stateId).then(state => {
                            this.props.organisationMemberStore.setMembers(state.members);
                            this.props.organisationMemberStore.setStateId(state.id);
                            this.props.organisationMemberStore.setLevel(2);
                            this.props.regionStore.setRegions(state.regions);
                        })
                    ]).then(() => {
                        this.setState({
                            ...this.state,
                            isLoading: false
                        });
                    });
                }
            );
        }
    }

    handleNameChange = e => {
        this.props.stateStore.setName(e.target.value);
        this.props.templateStore.closeStateBlock();
    };
    handleAddressChange = e => {
        this.props.stateStore.setAddress(e.target.value);
        this.props.templateStore.closeStateBlock();
    };
    handleContactNumberChange = e => {
        this.props.stateStore.setContactNumber(e.target.value.replace(/\D/,''));
        this.props.templateStore.closeStateBlock();
    };

    handleSubmitForm = e => {
        e.preventDefault();
        const { level2Label } = this.props.organisationStore;
        this.setState(
            {
                ...this.state,
                isLoading: true
            })
        // submit
        this.props.stateStore.submit().then(() => {
            this.setState(
                {
                    ...this.state,
                    isLoading: false
                })
            this.props.templateStore.openSnackbar(`${level2Label} updated`);
            this.props.templateStore.openStateBlock();
        });
    };

    anyError(field) {
        if (!this.props.stateStore.errors) return false;
        if (!this.props.stateStore.errors[field]) return false;
        return true;
    }

    errorText(field) {
        if (!this.props.stateStore.errors) return null;
        if (!this.props.stateStore.errors[field]) return null;
        return this.props.stateStore.errors[field];
    }

    handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        this.setState({ open: false });
    };

    render() {
        const { name, address, contactNumber } = this.props.stateStore;
        const { level1Label, level2Label, level3Label } = this.props.organisationStore;
        const { stateBlock } = this.props.templateStore;
        const breadcrumb = [
            { name: "Dashboard", link: "/staff" },
            { name: "Organisation", link: "/organisation" },
            {
                name: this.props.organisationStore.name,
                link: this.props.organisationStore.canManage ? `/organisation/${this.props.match.params.id}/edit` : undefined
            },
            { name: this.props.stateStore.name }
        ];

        var canManage = this.props.stateStore.canManage || this.props.organisationStore.canManage;

        return (
            <main>
                <Prompt when={stateBlock} message={location => `You have unsaved State data, do you still want to leave this section?`} />
                <Header userRole="agent" />
                <Sidebar />
                <MainContainer>
                    <Breadcrumb links={breadcrumb} />
                    <Heading title={"Edit " + level2Label} />
                    <div style={{ position: "relative" }}>
                        <Loading showed={this.state.isLoading} />
                        <Paper>
                            <form onSubmit={this.handleSubmitForm} className="org-form">
                                <Grid container spacing={16}>
                                    <Grid item xs={12}>
                                        <Grid container spacing={8}>
                                            <Grid item xs={12}>
                                                <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
                                                    <Typography variant="subtitle1" style={{ fontWeight: 700, color: "#333", fontSize: 15 }}>{level2Label}</Typography>
                                                    <Tooltip title={`${level2Label} is the level 2 group in your organisation hierarchy. You can add multiple ${level3Label}s under this ${level2Label}.`} placement="right">
                                                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 16, height: 16, borderRadius: "50%", background: "#e5e7eb", color: "#6b7280", fontSize: 10, fontWeight: 700, cursor: "help", flexShrink: 0 }}>?</span>
                                                    </Tooltip>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <TextField
                                                    id="org-name"
                                                    label={`${level2Label} Name`}
                                                    fullWidth
                                                    value={name}
                                                    onChange={this.handleNameChange}
                                                    error={this.anyError("name")}
                                                    helperText={this.errorText("name")}
                                                    InputProps={{
                                                        readOnly: !canManage
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={8}>
                                                <TextField
                                                    id="org-address"
                                                    label="Address"
                                                    fullWidth
                                                    value={address}
                                                    onChange={this.handleAddressChange}
                                                    error={this.anyError("address")}
                                                    helperText={this.errorText("address")}
                                                    InputProps={{
                                                        readOnly: !canManage
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    id="org-contactNumber"
                                                    label="Contact Number"
                                                    fullWidth
                                                    value={contactNumber}
                                                    onChange={this.handleContactNumberChange}
                                                    error={this.anyError("contactNumber")}
                                                    helperText={this.errorText("contactNumber")}
                                                    InputProps={{
                                                        readOnly: !canManage
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container spacing={8}>
                                            <Grid item xs={12}>
                                                <UserTable level={2} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container spacing={8}>
                                            <Grid item xs={12}>
                                                <RegionTable />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className="action">
                                            <Button component={Link} to={`/organisation/${this.props.match.params.id}/edit`}>
                                                Back
                                            </Button>
                                            &nbsp;
                                            {canManage ? (
                                                <Button variant="contained" color="primary" type="submit" id="state-submit">
                                                    Save
                                                </Button>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </Grid>
                                </Grid>
                            </form>
                        </Paper>
                    </div>
                </MainContainer>
            </main>
        );
    }
}
export default StateEdit;
